import { render } from "./RoleDash.vue?vue&type=template&id=df7452e4"
import script from "./RoleDash.vue?vue&type=script&lang=js"
export * from "./RoleDash.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__